import {createContext, useContext, useEffect, useState} from 'react';
import {
  linkIsPublicPageQueryResultLinksDovetaleAffiliateLink,
  PublicPageQueryResultPage,
} from 'graphql/queries/LinkpopQuery';
import {AffiliateProduct, getAffiliateProducts} from 'shared/CollabsApi';

type DovetaleAffiliateLinkContext = {
  loaded: boolean;
  setLoaded: React.Dispatch<React.SetStateAction<boolean>>;
  products: Array<AffiliateProduct>;
  setProducts: React.Dispatch<React.SetStateAction<Array<AffiliateProduct>>>;
};

const context = createContext<DovetaleAffiliateLinkContext | null>(null);

type DovetaleAffiliateLinkContextProviderProps = {
  links: PublicPageQueryResultPage['links'];
  children: React.ReactNode;
};

export const DovetaleAffiliateLinkContextProvider = (
  props: DovetaleAffiliateLinkContextProviderProps,
) => {
  const {links, children} = props;

  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [products, setProducts] = useState<Array<AffiliateProduct>>([]);

  const loadProducts = async () => {
    if (loading) {
      return;
    }

    setLoading(true);

    const ids = links
      .filter(linkIsPublicPageQueryResultLinksDovetaleAffiliateLink)
      .map((link) => link.productId);

    const products = await getAffiliateProducts(ids, DOVETALE_API_HOST);
    if (products) {
      setProducts(products.data.nodes);
    }

    setLoading(false);
    setLoaded(true);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => void loadProducts(), []);

  return (
    <context.Provider value={{loaded, setLoaded, products, setProducts}}>
      {children}
    </context.Provider>
  );
};

export const useDovetaleAffiliateLinkContext = () => useContext(context);
